var error = {
  translation: {
    error: {
      coreNotFound: 'Không tải được cài đặt cốt lõi',
      domainNotAllowed: 'Bạn không thể đăng ký bằng email thuộc miền này',
      emailAlreadyInUse: 'Email đã được sử dụng',
      insufficientPermissions: 'Không đủ quyền',
      invalidCurrentPassword: 'Mật khẩu hiện tại không đúng',
      invalidPermissions: 'Vui lòng chọn ít nhất một quyền',
      invalidUsernameOrPassword: 'Tên đăng nhập hoặc mật khẩu không đúng',
      localRegistrationDisabled:
        'Quản trị viên đã tắt đăng ký cục bộ cho người dùng',
      noInternetConnection: 'Không có kết nối internet',
      noOidcProfileFound: 'Không tìm thấy hồ sơ OIDC',
      policyNotAccepted: 'Vui lòng chấp nhận Điều khoản dịch vụ và Chính sách bảo mật',
      registrationDisabled: 'Quản trị viên đã tắt mọi hình thức đăng ký người dùng',
      serverConnectionFailed: 'Kết nối máy chủ thất bại',
      ssoRegistrationDisabled:
        'Quản trị viên đã tắt đăng ký SSO cho người dùng',
      tooManyFailedAttempts:
        'Quá nhiều lần thử không thành công — Vui lòng thử lại sau',
      unknownError: 'Lỗi không xác định, vui lòng thử lại sau',
      usernameAlreadyInUse: 'Tên đăng nhập đã được sử dụng',
      weakPassword: 'Vui lòng dùng mật khẩu mạnh hơn',
    },
  },
};

export { error as default };
